<div class="new-client">
    <div class="client-form">
        <mat-icon  (click)='close()' class="close-button">clear</mat-icon>

        <div class="client-form-inner">
            <h3 >Add new Folder</h3>
            <form [formGroup]="newFolder" class="folder-form">
                 <mat-form-field appearance="outline" [hideRequiredMarker]="true">
                     <mat-label >Folder name</mat-label>
                     <input  formControlName="name" type="text" matInput placeholder="" value="" >
                 </mat-form-field>
                 <div  class="buttonDiv">
                     <button mat-button class="add-client-button"  type="submit"  (click)="createFolder()"> Create folder
                     </button>
                 </div>
            </form>
        </div>
    </div>
</div>
